__turbopack_context__.v({
  "previewCount": "PreviewSection-module-scss-module__RVwf9a__previewCount",
  "previewItem": "PreviewSection-module-scss-module__RVwf9a__previewItem",
  "previewList": "PreviewSection-module-scss-module__RVwf9a__previewList",
  "previewZero": "PreviewSection-module-scss-module__RVwf9a__previewZero",
  "section": "PreviewSection-module-scss-module__RVwf9a__section",
  "sectionTitle": "PreviewSection-module-scss-module__RVwf9a__sectionTitle",
  "statCard": "PreviewSection-module-scss-module__RVwf9a__statCard",
  "statLabel": "PreviewSection-module-scss-module__RVwf9a__statLabel",
  "statValue": "PreviewSection-module-scss-module__RVwf9a__statValue",
  "statsGrid": "PreviewSection-module-scss-module__RVwf9a__statsGrid",
});
